import { render, staticRenderFns } from "./test-item.vue?vue&type=template&id=5ba596fa&scoped=true"
import script from "./test-item.vue?vue&type=script&lang=js"
export * from "./test-item.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=5ba596fa&prod&scoped=true&lang=css&external"
import style1 from "./test-item.vue?vue&type=style&index=1&id=5ba596fa&prod&scoped=true&lang=css"
import style2 from "./test-item.vue?vue&type=style&index=2&id=5ba596fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba596fa",
  null
  
)

export default component.exports